module.exports = __webpack_public_path__ + "img/e32d2ca7543f4d03a281094ce5489bd9.724c66a0.jpg";